import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueNotifications from 'vue-notification';

import App from './components/App';
import routes from './routes';
import store from './store';
import PaceProgress from 'pace-progress';
import VueQuillEditor from 'vue-quill-editor';
import VueMeta from 'vue-meta';
import {authHeader} from './helpers';

import axios from 'axios';

import './leaflet-marker-patch';
import 'bootstrap';

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

import { API_URL } from './constants';

window.$ = require('jquery');
window.axios = axios.create({
    baseURL: API_URL,
});

Vue.use(VueMeta, {
	keyName: 'meta',
});
Vue.use(VueNotifications);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueQuillEditor, {
	modules: {
		toolbar: [
			['bold', 'italic', 'underline', 'strike'],
			['blockquote', 'code-block'],
			[{ 'header': 1 }, { 'header': 2 }],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }],
			[{ 'script': 'sub' }, { 'script': 'super' }],
			[{ 'indent': '-1' }, { 'indent': '+1' }],
			[{ 'direction': 'rtl' }],
			[{ 'size': ['small', false, 'large', 'huge'] }],
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
			[{ 'color': [] }, { 'background': [] }],
			[{ 'font': [] }],
			[{ 'align': [] }],
			['clean'],
			['link'],
		],
	},
});

axios.interceptors.response.use(response => response, error => {
    if (error && error.response && error.response.status === 401 && store.getters['auth/isAuthenticated'])
        store.dispatch('auth/logout');

    return Promise.reject(error);
});

if ('auth' in localStorage) {
	try {
		const auth = JSON.parse(localStorage.getItem('auth'));

		if (auth.accessToken && auth.obtainedAt + auth.expiresIn > Date.now()) {
			axios.defaults.headers.common[authHeader] = `Bearer ${auth.accessToken}`;

			store.commit('auth/LOGIN', auth);
		} else {
			localStorage.removeItem('auth');
			delete axios.defaults.headers.common[authHeader];
		}
	} catch (e) {
		localStorage.removeItem('auth');
	}
}

const router = new VueRouter({
	routes,
	mode: 'history',
	linkActiveClass: 'active',
	base: '/dashboard',
	scrollBehavior: (to, from, savedPosition) => ({x: 0, y: 0}),
});

router.beforeEach((to, from, next) => {
	store.dispatch('setContentLocale', 'en');
	
	if (to.name !== 'login' && !store.getters['auth/isAuthenticated'])
		next({name: 'login'});
	else
		next();
});

let hasFullControl = () => store.state.auth.self.mainAdmin;
Vue.mixin({
	methods: {
		hasFullControl,
		can: permission => hasFullControl() || store.state.auth.self.permissions.filter(c => c.name == permission).length > 0,
		canAny: permission => hasFullControl() || store.state.auth.self.permissions.filter(c => c.name.includes(permission)).length > 0,
		canByModel: model => hasFullControl() || store.state.auth.self.permissions.filter(c => c.model != null && c.model.toLowerCase().includes(model.toLowerCase())).length > 0,
		canOnModel: (permission, id) => hasFullControl() || store.state.auth.self.permissions
			.filter(c => c.editable_models && c.editable_models.filter(x => x.model_id == id).length > 0)
			.filter(c => c.name == permission)
			.length > 0,
	}
});

new Vue({
	el: '#app',
	render: h => h(App),
	router,
	store,
});

PaceProgress.start();